<div class="{{styleClass}}">
  <span [innerHTML]="currentText"></span>
  <span class="p-description-a" [class.hidden]="hideToggle" *ngIf="!(!this.text || this.text.length <= this.maxLength)" (click)="toggleView()"
    [ngClass]="{'d-block' : !isCollapsed}">View
    {{ isCollapsed ? 'more' : 'less' }}</span>
</div>